function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import IntlMessage from '../commons/Intl';
import { Organization, Action, Label, EnableOptions } from '../commons/IntlMessages';
import { OrganizationStatusTypes } from "../enum/OrganizationStatusTypes";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // ページモーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * サポート
   */

  Mode[Mode["Support"] = 3] = "Support";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Support:
        _this.state = {
          Modal: null,
          OrganizationId: _this.props.organizationId,
          OrganizationName: _this.props.organizationName,
          ExtentionFlg: _this.props.extentionFlg,
          ErrorMessages: []
        };
        break;

      default:
        throw Error();
    }

    return _this;
  }
  /**
   * 拡張フラグを更新します。
   *
   * @param e イベント
   */


  _createClass(MainComponent, [{
    key: "updateExtentionFlg",
    value: function updateExtentionFlg(e) {
      this.setState({
        ExtentionFlg: e.target.value
      });
    }
    /**
     * 「更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "onModify",
    value: function onModify() {
      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (!this.props.organizationId) {
          throw Error();
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        this.props.onChangeActualExtentionFlg(this.props.organizationId, Number(this.state.ExtentionFlg), this.props.updateDateTime);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#OrganizationSupportModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this2.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "OrganizationSupportModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/organization_icon.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Organization.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "OrganizationName"
      }, intl.format(Label.OrganizationName)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-form-label"
      }, this.state.OrganizationName))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Support"
      }, intl.format(Label.Support)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, [OrganizationStatusTypes.UnderContract, OrganizationStatusTypes.Deleted, OrganizationStatusTypes.Suspended, OrganizationStatusTypes.Trial].some(function (x) {
        return x == _this3.props.organizationStatus;
      }) && /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "Support",
        name: "Support",
        onChange: function onChange(e) {
          return _this3.updateExtentionFlg(e);
        },
        value: this.state.ExtentionFlg,
        tabIndex: 105
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled))), [OrganizationStatusTypes.NoContract, OrganizationStatusTypes.ScheduleContract].some(function (x) {
        return x == _this3.props.organizationStatus;
      }) && /*#__PURE__*/React.createElement("label", {
        className: "col-form-label"
      }, this.state.ExtentionFlg == "1" ? intl.format(EnableOptions.Enabled) : intl.format(EnableOptions.Disabled)))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, [OrganizationStatusTypes.UnderContract, OrganizationStatusTypes.Deleted, OrganizationStatusTypes.Suspended, OrganizationStatusTypes.Trial].some(function (x) {
        return x == _this3.props.organizationStatus;
      }) && /*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update))))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };